"use client"

import { Button } from "@/elements"
import { PortfolioStaticDataQuery } from "@/gql/graphql"
import { updatePathShallow } from "@/utils/updatePathShallow"
import { useSearchParams } from "next/navigation"
import { FC, useEffect } from "react"
import { PortfolioUIState } from "../page"
import { FilterLoader } from "./ProjectFilters/FiltersLoader"
import { ampli } from "@/ampli"
import type { NovaSession } from "@/types"
import { decodeGraphqlNodeId } from "@/tracking"
import { useEditPortfolio } from "./edit/useEditPortfolio"

type Tab = "work" | "about"

interface Props {
  onChangeTab: (tab: Tab) => void
  activeTab: Tab
  staticData: PortfolioStaticDataQuery | null | undefined
  uiState: PortfolioUIState
  serverSession: NovaSession | null
  editProfileMethods?: ReturnType<typeof useEditPortfolio>
}

export const TabsWithFilterButton: FC<Props> = props => {
  const { onChangeTab, activeTab, staticData, uiState, serverSession, editProfileMethods } = props
  const searchParams = useSearchParams()

  useEffect(() => {
    const tabParam = searchParams?.get("tab") as Tab | null
    if (tabParam && (tabParam === "work" || tabParam === "about")) {
      onChangeTab(tabParam)
    }
  }, [searchParams, onChangeTab])

  const handleChangeTab = (tab: Tab) => {
    if (tab === "about") {
      ampli.profileAboutView({
        creative_id: decodeGraphqlNodeId(staticData?.creativeByHandle.id).numericalId || "",
      })
    }
    onChangeTab(tab)

    // Update the searchParams with the new tab value
    const current = searchParams ? new URLSearchParams(Array.from(searchParams.entries())) : new URLSearchParams()
    current.set("tab", tab)

    // Update the URL without reloading the page
    const query = current.toString() ? `${current.toString()}` : ""
    updatePathShallow(query)
  }

  return (
    <div className="flex flex-row justify-between">
      <div className="flex flex-row gap-2">
        <Button onClick={() => handleChangeTab("work")} variant={activeTab === "work" ? "grey-fill" : "transparent"}>
          Work
        </Button>
        <Button onClick={() => handleChangeTab("about")} variant={activeTab === "about" ? "grey-fill" : "transparent"}>
          About
        </Button>
      </div>
      {staticData && !editProfileMethods?.isEditing ? (
        <FilterLoader staticData={staticData} uiState={uiState} />
      ) : (
        <div />
      )}
    </div>
  )
}
